import { useAiAskBarActions } from './useAiAskBarActions'
import { useAiAskBarModel } from './useAiAskBarModel'
import AiAskBarRootView from './AiAskBarRootView'

/**
 * @param {import('./aiAskBarProps').AiAskBarProps} props
 */
export default function AiAskBarView(props) {
  const vm = useAiAskBarModel(props)
  const actions = useAiAskBarActions({
    model: vm,
    onSend: props.onSend,
    sendDisabled: props.sendDisabled,
    onDictationSessionEnd: props.onDictationSessionEnd,
    selectedModel: props.model,
    onScheduleMessage: props.onScheduleMessage,
    ensureChatId: props.ensureChatId,
  })

  return <AiAskBarRootView vm={vm} actions={actions} {...props} />
}
